var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12665",
    "data-name": "Group 12665",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.595,
    height: 26.831,
    viewBox: "0 0 26.595 26.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3595",
    "data-name": "Rectangle 3595",
    width: 5.733,
    height: 26.831,
    rx: 2.867,
    transform: "translate(0 0)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3596",
    "data-name": "Rectangle 3596",
    width: 5.733,
    height: 20.45,
    rx: 2.867,
    transform: "translate(10.431 6.382)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3597",
    "data-name": "Rectangle 3597",
    width: 5.733,
    height: 25.731,
    rx: 2.867,
    transform: "translate(20.861 1.1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCas);
export default __webpack_public_path__ + "static/media/cas.0841ae18.svg";
export { ForwardRef as ReactComponent };